<template>
  <div style="position: relative;">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <div class>
          <el-card shadow="never">
            <div slot="header">
              <span class="title">订单信息</span>
            </div>
            <el-steps :active="isdzf?3:4" align-center style="border-bottom:1px solid #E9E9E9;padding-bottom:20px;">
              <el-step title="准备充电" :description="rowdata.startTime" />
              <el-step title="开始充电" :description="rowdata.startTime" />
              <el-step title="结束充电" :description="rowdata.endTime" />
              <el-step title="订单支付" :description="rowdata.payTime" />
            </el-steps>
            <div style="margin:20px auto 0; width:90%; color:cornflowerblue; font-size: 20px;">
              订单结束原因：{{ rowdata.stopReasonDesc ? rowdata.stopReasonDesc : 'APP远程停止' }}</div>
            <div
              style="width:90%;height:110px;margin:0 auto;display: flex; align-items:center;justify-content: space-between; border-bottom:1px solid #E9E9E9;"
            >
              <div style="width: 40%;color:#999999;font-size:12px;text-align: center;">
                <div>订单总金额</div>
                <span
                  style="color:#1890FF;font-size:36px;"
                >{{ getFloat(rowdata.totalMoney) }}</span>
                <span style="color:#333333;">元</span>
              </div>
              <div style="width: 40%;color:#999999;font-size:12px;text-align: center;">
                <div>订单总优惠</div>
                <span style="color:#1890FF;font-size:36px;">{{ getFloat(rowdata.totalSavedMoney) }}</span>
                <span style="color:#333333;">元</span>
              </div>
              <div v-if="isdzf" style="width: 40%;color:#999999;font-size:12px;text-align: center;">
                <div>实收金额</div>
                <span style="color:#1890FF;font-size:36px;"> -- </span>
              </div>
              <div v-else style="width: 40%;color:#999999;font-size:12px;text-align: center;">
                <div>实收金额</div>
                <span style="color:#1890FF;font-size:36px;">{{ getFixed2(rowdata.totalMoneyActual) }}</span>
                <span style="color:#333333;">元</span>
                <br>
                <span style="color:#1890FF">电费：￥{{ getFixed2(rowdata.elecMoneyActual) }}&nbsp;&nbsp;&nbsp;服务费：￥{{ getFixed2(rowdata.seviceMoneyActual) }}</span>
              </div>
            </div>
            <div class style="width:90%;margin:0 auto;padding-top:26px;">
              <SForm
                ref="formref"
                :fields="formfields"
                :data-form="rowdata"
                label-width="100px"
                :is-show-btn="false"
                form-style="width:calc(50% - 10px);display:inline-block"
                label-position="left"
              />
            </div>
          </el-card>
          <el-card shadow="never">
            <div slot="header">
              <span class="title">充电信息</span>
            </div>
            <el-table :data="tableData" border :summary-method="getSummaries" show-summary style="width: 100%;">
              <el-table-column prop="time" label="充电时段" />
              <el-table-column prop="eleMoney" label="电费单价(元/度)" />
              <el-table-column prop="serMoney" label="服务费单价(元/度)" />
              <el-table-column prop="power" label="充电度数(度)" />
              <el-table-column prop="money" label="费用(元)" />
            </el-table>
          </el-card>
          <el-card shadow="never">
            <div slot="header">
              <span class="title">优惠抵扣</span>
            </div>
            <div style="padding:10px;border:1px solid #e0e0e0">
              <div style="width:100%;font-size: 16px;">电站活动</div>
              <div style="display: flex; flex-direction: row; justify-content: center;">
                <div style="width: 33%; ">
                  <div>优惠电费</div>
                  <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.elecMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: center;">
                  <div>优惠服务费</div>
                  <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.seviceMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: right;">
                  <div>优惠总费用</div>
                  <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.totalMoney):'--' }}元</div>
                </div>
              </div>
            </div>
            <div v-if="!isdzf" style="padding:10px;border:1px solid #e0e0e0;margin-top:10px">
              <div style="width:100%;font-size: 16px;">权益抵扣<span style="font-size: 14px;">（权益编号：{{ rowdata.privilegeDiscount?rowdata.privilegeDiscount.sourceName:'--' }}）</span></div>
              <div style="display: flex; flex-direction: row; justify-content: center;">
                <div style="width: 33%; ">
                  <div>抵扣电费</div>
                  <div style="margin-top:10px">{{ rowdata.privilegeDiscount?getFloat(rowdata.privilegeDiscount.elecMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: center;">
                  <div>抵扣服务费</div>
                  <div style="margin-top:10px">{{ rowdata.privilegeDiscount?getFloat(rowdata.privilegeDiscount.seviceMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: right;">
                  <div>抵扣总费用</div>
                  <div style="margin-top:10px">{{ rowdata.privilegeDiscount?getFloat(rowdata.privilegeDiscount.totalMoney):'--' }}元</div>
                </div>
              </div>
            </div>
            <div v-if="!isdzf" style="padding:10px;border:1px solid #e0e0e0;margin-top:10px">
              <div style="width:100%;font-size: 16px;">优惠券抵扣<span style="font-size: 14px;">（优惠券编号：{{ rowdata.couponDiscount?rowdata.couponDiscount.sourceName:'--' }}）</span></div>
              <div style="display: flex; flex-direction: row; justify-content: center;">
                <div style="width: 33%; ">
                  <div>抵扣电费</div>
                  <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.elecMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: center;">
                  <div>抵扣服务费</div>
                  <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.seviceMoney):'--' }}元</div>
                </div>
                <div style="width: 33%; text-align: right;">
                  <div>抵扣总费用</div>
                  <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.totalMoney):'--' }}元</div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card shadow="never">
            <div slot="header">
              <span class="title">抹零费用</span>
            </div>
            <div
              style="padding-top: 20px; padding-bottom: 20px; display: flex; flex-direction: row; justify-content: center;"
            >
              <div style="width: 33%; ">
                <div>抹零电费</div>
                <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.elecMoney):'--' }}元</div>
              </div>
              <div style="width: 33%; text-align: center;">
                <div>抹零服务费</div>
                <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.seviceMoney):'--' }}元</div>
              </div>
              <div style="width: 33%; text-align: right;">
                <div>抹零总费用</div>
                <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.totalMoney):'--' }}元</div>
              </div>
            </div>
          </el-card>
        </div>
      </el-tab-pane>
         <el-tab-pane label="实时数据（列表）" name="dataTable" >
    <STable
    v-if="tabName==='dataTable'"
      ref="tableref"
      :url="url"
      :columns="columns"
      :selection="false"
    />
      </el-tab-pane>
      <el-tab-pane label="实时数据（图表）" name="dataEcharts">
        <div class="orderBox">
          <div class="title">
            <div class="word">需求/输出电压</div>
              <el-checkbox-group v-model="checkList" class="checkGroup" @change="handleCheckAllChange">
    <el-checkbox label="需求电压"></el-checkbox>
    <el-checkbox label="实际输出电压"></el-checkbox>
  </el-checkbox-group>
            </div>
          <div id="echartsContent1" class="content"></div>
        </div>
        <div class="orderBox">
          <div class="title">
              <div class="word">需求/输出电流</div>
              <el-checkbox-group v-model="checkList2" class="checkGroup" @change="handleCheckAllChange2">
    <el-checkbox label="需求电流"></el-checkbox>
    <el-checkbox label="实际输出电流"></el-checkbox>
  </el-checkbox-group>
          </div>
          <div id="echartsContent2" class="content"></div>
        </div>
        <div class="orderBox">
          <div class="title">            
            <div class="word">枪线温度</div>
            </div>
          <div id="echartsContent3" class="content"></div>
        </div> 
        </el-tab-pane>
    </el-tabs>
    <el-button type="primary" plain style="position: absolute;right:30px;top:5px;" @click="cancel()">返回</el-button>
  </div>
</template>

<script>
import {
  HOST,
  EV_HOST
} from '@/utils/host'
import realTimeList from './components/real-time-list.vue'
import realTimeChart from './components/real-time-chart.vue'
export default {
  name: 'AddEnterprise',
  components: {
    realTimeList: realTimeList,
    realTimeChart: realTimeChart
  },
  data() {
    return {
      url: "/logs/logs/page?orderNo=0000000000000000000000000000000&msgType=19",
         checkList:['需求电压', '实际输出电压'],
      checkList2:['需求电流','实际输出电流'],
      showStatus:true,
            tableData:[],
      tableData2:[],
      payShowStauts:false,
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      data5:[],
          data6:[],
      data7:[],
      data8:[],
          tempdata:{
        trafficName:'--',
        elecMoney:'--',
        seviceMoney:'--',
        totalMoney:'--',
      },
            tempData1:[],
      tempData2:[],
      tempData3:[],
      tempData4:[],
            columns: [
        {
          label: "上送时间",
          prop: "timeStr"
        },
        {
          label: "充电电量（度）",
          prop: "充电度数"
        },
        {
          label: "充电时长（分钟）",
          prop: "累计充电时间"
        },
        {
          label: "SOC",
          prop: "SOC"
        },
        {
          label: "已充金额（元）",
          prop: "已充金额",
          // template: (index, reocrd) => {
          //   return this.getFloat(reocrd.totalPower);
          // }
        },
        {
          label: "电压（V）",
          prop: "输出电压",
          // template: (index, reocrd) => {
          //   return reocrd.SOC ? parseFloat(reocrd.SOC) + "%" : "--";
          // }
        },
        {
          label: "电流（A）",
          prop: "输出电流"
        },
        {
          label: "枪线温度（℃）",
          prop: "枪线温度",
          width: "150px"
        },
        {
          label: "电池温度（℃）",
          prop: "电池组最高温度"
        },
      ],
      isdzf: '',
      tabName: 'first',
      delay: 0,
      rowdata: {},
      formfields: [{
        label: '充电单号',
        type: 'div',
        style: 'width:100%',
        prop: 'startChargeSeq'
      },
      {
        label: '用户账号',
        type: 'div',
        style: 'width:100%',
        prop: 'loginName'
      },
      {
        label: '用户姓名',
        type: 'div',
        style: 'width:100%',
        prop: 'userName'
      },
      {
        label: '归属企业',
        type: 'div',
        style: 'width:100%',
        prop: 'belongOrg'
      },
      {
        label: '充电车辆',
        type: 'div',
        style: 'width:100%',
        prop: 'plateNumber'
      },
      {
        label: '车辆VIN码',
        type: 'div',
        prop: 'VINCode'
      },
      {
        label: '充电卡号',
        type: 'div',
        style: 'width:100%',
        prop: 'cardNum'
      },
      {
        label: '运营商流水号',
        type: 'div',
        style: 'width:100%',
        prop: 'outStartChargeSeq'
      },
      {
        label: '流量方流水号',
        type: 'div',
        style: 'width:100%',
        prop: 'hlhtStartChargeSeq'
      },
      // {
      //     label: "订单类型",
      //     type: "div",
      //     prop: "orderType",
      // },
      // {
      //     label: "充电模式",
      //     type: "div",
      //     prop: "chargingType",
      // },
      {
        label: '终端名称',
        type: 'div',
        style: 'width:100%',
        prop: 'connectorName'
      },
      {
        label: '电桩品牌',
        type: 'div',
        style: 'width:100%',
        prop: 'equipmentBrand'
      },
      {
        label: '电桩型号',
        type: 'div',
        style: 'width:100%',
        prop: 'equipmentModel'
      },
      {
        label: '电桩功率',
        type: 'div',
        style: 'width:100%',
        prop: 'equipPower'
      },
      {
        label: '电站名称',
        type: 'div',
        style: 'width:100%',
        prop: 'stationName'
      },
      {
        label: '运营商',
        type: 'div',
        style: 'width:100%',
        prop: 'orgName'
      },
      {
        label: '运营商属性',
        type: 'div',
        style: 'width:100%',
        prop: 'attrValue'
      }],
      // tableData: [],
        tableData3: [],
      id: '',
      chargeNum: ''
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    // console.log(this.$route.query.num,123456456);
            this.url=`/logs/logs/page?orderNo=${this.$route.query.num}&msgType=19`
    // console.log(this.$route.query.data.id,6666666666);
    this.id = this.$route.query.data
    this.chargeNum = this.$route.query.num
    this.isdzf = this.$route.query.isdzf
    if (!this.$route.query.isdzf) {
      const newdata = {
        label: '结算方式',
        type: 'div',
        style: 'width:100%',
        prop: 'payType'
      }
      const newdata1 = {
        label: '异常原因',
        type: 'div',
        style: 'width:100%',
        prop: 'payTypeDesc'
      }
      this.formfields.push(newdata)
      this.formfields.push(newdata1)
    }
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
    watch:{
   tableData3:{
    handler(newval){
    if(newval.length>0){
      // clearInterval(this.timer)
      // this.timer=null
      let a=[]
      this.data5=[]
      this.data8=[]
      a=JSON.parse(JSON.stringify(newval)).reverse()
      a.forEach(item=>{
        this.data5.push(item.枪线温度)
        this.data8.push(item.timeStr)
      })
      if(this.tabName=='dataEcharts'){
      this.loadEachrts3()
      }
    //  this.data5=a
    }
    },
    deep:true
   },
     tableData2:{
    handler(newval){
    if(newval.length>0){
      let a=[]
      a=JSON.parse(JSON.stringify(newval)).reverse()
      this.data1=[]
      this.data2=[]
      this.data3=[]
      this.data4=[]
      this.data6=[]
      this.data7=[]
      a.forEach(item=>{
        this.data1.push(item.BMS电压需求)
        this.data2.push(item.电桩电压输出值)
                this.data3.push(item.BMS电流需求)
        this.data4.push(item.电桩电流输出值)
        this.data6.push(item.timeStr)
        this.data7.push(item.timeStr)
      })
      this.tempData1=this.data1
      this.tempData2=this.data2
      this.tempData3=this.data3
      this.tempData4=this.data4
      if(this.tabName=='dataEcharts'){
      this.loadEachrts()
      this.loadEachrts2()
      }
    }
    },
    deep:true
   }
  },
  methods: {
            handleCheckAllChange(e){
      if(e.length===2){
         this.data1= this.tempData1
        this.data2=this.tempData2
        this.loadEachrts()
      }
      else{
        if(JSON.stringify(e)==JSON.stringify(['需求电压'])){
                this.data1=this.tempData1
                this.data2=[]
                  this.loadEachrts()
        }
             if(JSON.stringify(e)==JSON.stringify(['实际输出电压'])){
                this.data1= []
              this.data2=this.tempData2
                this.loadEachrts()
        }
      }
            if(e.length==0){
          this.data1= []
              this.data2=[]
              this.loadEachrts()
      }
    },
        handleCheckAllChange2(e){
      if(e.length===2){
         this.data3= this.tempData3
        this.data4=this.tempData4
        this.loadEachrts2()
      }
      else{
        if(JSON.stringify(e)==JSON.stringify(['需求电流'])){
                this.data3=this.tempData3
                this.data4=[]
                  this.loadEachrts2()
        }
             if(JSON.stringify(e)==JSON.stringify(['实际输出电流'])){
                this.data3= []
              this.data4=this.tempData4
                this.loadEachrts2()
        }
      }
                  if(e.length===0){
          this.data3= []
              this.data4=[]
                this.loadEachrts2()
      }
    },
      handleClick(tab, event) {
        if(tab.name==='dataEcharts'){
                        const data2 = {
           orderNo: this.$route.query.num,
        msgType: '19',
        pageNo:1,
        pageSize:10,
        loading:true
      }
        this.$store.dispatch('form/handle', {
        url: '/logs/logs/page',
        data: data2,
        method: 'get',
        callback: (resp) => {
          this.tableData3=resp.list
}
      })
                 const data = {
           orderNo: this.$route.query.num,
        msgType: '35',
      }
        this.$store.dispatch('form/handle', {
        url: '/logs/logs/page',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.tableData2=resp.list
}
      })
          this.$nextTick(()=>{
          this.loadEachrts()
          this.loadEachrts2()
          this.loadEachrts3()
          })
          // setTimeout(()=>{
          // },1000)
        }
      },
    loadEachrts() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent1")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["需求电压", "实际电压"],
          right:'3%',
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "15%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#FF0000','#1890FF'],
        xAxis: {
          type: "category",
          data: this.data6,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "需求电压",
            type: "line",
            data:this.data1,
            // color:'#FF0000'
          },
          {
            name: "实际电压",
            type: "line",
            data: this.data2,
            // color:"#1890FF;"
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
      loadEachrts2() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent2")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["需求电流", "实际电流"],
             right:'3%',
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "15%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#FF0000','#1890FF'],
        xAxis: {
          type: "category",
          data: this.data7,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "需求电流",
            type: "line",
            data:this.data3,
            // color:'#FF0000'
          },
          {
            name: "实际电流",
            type: "line",
            data: this.data4,
            // color:"#1890FF;"
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
          loadEachrts3() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent3")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          show:false,
          data: ["枪线温度"],
          right:0,
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "5%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#1890FF'],
        xAxis: {
          type: "category",
     data: this.data8,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "枪线温度",
            type: "line",
            data:this.data5,
            // color:'#FF0000'
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
    cancel() {
      // console.log(this.$route.path,'hhhhhh') 
      // return
      if(this.$route.path==='/orderManagement/historyDetaill'){
      localStorage.setItem("tabName", "second");
      }
      this.$router.go(-1)
    },
    getSummaries(param) {
      const {
        columns,
        data
      } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总时长：' + (this.rowdata.chargeTime)
          return
        }
        if (index === 3) {
          console.log(column, 'dddffff')
        }
        const values = data.map(item => Number(item[column.property]))
        console.log(column.property, 'ppouuh')
        if (column.property === 'power') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index]
        } else if (column.property === 'money') {
          sums[index] = this.rowdata.totalMoney
          sums[index]
        }
      })
      sums[3] = this.getFloat(sums[3])
      sums[4] = this.getFloat(sums[4])
      console.log(sums, 'ssss')

      return sums
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/getHistoryOrderDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp

          if (resp.chargeDetails) {
            const aa = JSON.parse(resp.chargeDetails)
            const bb = []
            if (!resp.outStartChargeSeq) {
              bb.push({
                time: '时段1',
                eleMoney: aa['时段1电费单价'],
                serMoney: aa['时段1服务费单价'],
                power: aa['时段1电量'],
                money: aa['时段1金额']
              })
             bb.push({
                time: '时段2',
                eleMoney: aa['时段2电费单价'],
                serMoney: aa['时段2服务费单价'],
                power: aa['时段2电量'],
                money: aa['时段2金额']
              })
                 bb.push({
                time: '时段3',
                eleMoney: aa['时段3电费单价'],
                  serMoney: aa['时段3服务费单价'],
                power: aa['时段3电量'],
                money: aa['时段3金额']
              })
                 bb.push({
                time: '时段4',
                eleMoney: aa['时段4电费单价'],
                 serMoney: aa['时段4服务费单价'],
                power: aa['时段4电量'],
                money: aa['时段4金额']
              })
                 bb.push({
                time: '时段5',
                eleMoney: aa['时段5电费单价'],
               serMoney: aa['时段5服务费单价'],
                power: aa['时段5电量'],
                money: aa['时段5金额']
              })
                 bb.push({
                time: '时段6',
                eleMoney: aa['时段6电费单价'],
                 serMoney: aa['时段6服务费单价'],
                power: aa['时段6电量'],
                money: aa['时段6金额']
              })
                 bb.push({
                time: '时段7',
                eleMoney: aa['时段7电费单价'],
                 serMoney: aa['时段7服务费单价'],
                power: aa['时段7电量'],
                money: aa['时段7金额']
              })
                 bb.push({
                time: '时段8',
                eleMoney: aa['时段8电费单价'],
                   serMoney: aa['时段8服务费单价'],
                power: aa['时段8电量'],
                money: aa['时段8金额']
              })
                 bb.push({
                time: '时段9',
                eleMoney: aa['时段9电费单价'],
                  serMoney: aa['时段9服务费单价'],
                power: aa['时段9电量'],
                money: aa['时段9金额']
              })
                 bb.push({
                time: '时段10',
                eleMoney: aa['时段10电费单价'],
              serMoney: aa['时段10服务费单价'],
                power: aa['时段10电量'],
                money: aa['时段10金额']
              })
            } else {
              for (var i = 0; i < aa.length; i++) {
                bb.push({
                  time: aa[i].DetailStartTime + '~' + aa[i].DetailEndTime,
                  eleMoney: aa[i].ElecPrice,
                  serMoney: aa[i].SevicePrice,
                  power: aa[i].DetailPower,
                  money: aa[i].DetailElecMoney + aa[i].DetailSeviceMoney
                })
              }
            }
            this.tableData = bb
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].eleMoney = this.getFloat(this.tableData[i].eleMoney)
              this.tableData[i].serMoney = this.getFloat(this.tableData[i].serMoney)
              this.tableData[i].power = this.getFloat(this.tableData[i].power)
              this.tableData[i].money = this.getFloat(this.tableData[i].money)
            }
          } else {
            this.tableData = []
          }

          if (resp.equipPower > 0) {
            this.rowdata.equipPower = resp.equipPower + 'KW'
          }

          if (this.rowdata.orgType === '0') {
            this.rowdata.orgType = '自营'
          } else if (this.rowdata.orgType === '1') {
            this.rowdata.orgType = '加盟'
          } else {
            this.rowdata.orgType = '互联互通'
          }
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .iconfont {
    width: 50px;
    height: 50px;
    margin: auto;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  /deep/ .el-form-item {
    .el-form-item__content {
      width: calc(100% - 120px);
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
    .orderBox {
  height: 306px;
  border: 1px solid rgba(121, 121, 121, 1);
  margin-bottom: 20px;
  .title {
    border-bottom: 3px solid #e1e1e1;
    padding-left: 50px;
    padding-right: 50px;
    display: flex;
    justify-content: space-between;
    .word{
    height: 42px;
    line-height: 42px;
        font-size: 18px;
    font-weight: 700;
    color: #333;
    }
    .checkGroup{
      line-height: 42px;
    }
  }
  .content{
    height: 264px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/historyDetail.vue